import { compose } from 'redux'

// shared higher order components
import withStripe from 'components/shared/withStripe'
import withFormResults from 'components/shared/withFormResults'
import withPathname from 'components/shared/withPathname'

// local higher-order components
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

const withRegistrationPaymentFormResults = withFormResults({
  mutation: 'savePayment',
  field: 'paymentProfile',
  redirect: '/confirm',
  successMessage: 'Payment method saved!',
  onSuccess: data =>
    window.dataLayer && window.dataLayer.push({ event: 'register.savePayment' })
})

// for registration flow
const withRegistrationPaymentForm = compose(
  withPathname, // for nav buttons
  withRegistrationPaymentFormResults, // for mutation result handling
  withMutation, // for saving payment and performing checkout
  withStripe, // for handling stripe API
  withEventHandlers // for handling UI interactions
)

export { withRegistrationPaymentForm }
